import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import React, { memo } from "react";

interface ActionCellItemProps {
    onClick: (event: React.MouseEvent) => void;
    icon: IconDefinition;
    color: string;
    label: string;
}

const ActionCellItem: React.FC<ActionCellItemProps> = memo(({ onClick, color, icon, label }) => {
    return (
        <GridActionsCellItem nonce={""} onResize={() => true} onResizeCapture={() => true} icon={<FontAwesomeIcon icon={icon} color={color} />} label={label} onClick={onClick} />
    );
});

export default ActionCellItem;
